module.exports = __webpack_public_path__ + "img/21.39257e57.png";